import { useState } from 'react';
import CountLink from './CountLink';
import SalesCycleAdmissionsDialog from './SalesCycleAdmissionsDialog';
import { prefetchSalesCycleAdmissions } from './salesCycleAdmissions';

// Makes the Admissions column on Sales Cycle Length clickable and owns the popup:
//   const drill = useSalesCycleDrilldown(month);
//   { field: 'admissionsCount', headerName: 'Admissions', align: 'right', render: drill.cell('admissionsCount') }
//   ...
//   {drill.dialog}
const useSalesCycleDrilldown = (month) => {
  const [open, setOpen] = useState(null);
  const requestFor = (row) => ({ userId: row.entityId, userName: row.entityName, month });

  const cell = (field) => (row) => (
    <CountLink
      count={row[field]}
      label={`admissions of ${row.entityName}`}
      onOpen={() => setOpen(requestFor(row))}
      onPrefetch={() => prefetchSalesCycleAdmissions(requestFor(row))}
    />
  );

  const dialog = open ? <SalesCycleAdmissionsDialog request={open} onClose={() => setOpen(null)} /> : null;
  return { cell, dialog };
};

export default useSalesCycleDrilldown;
